(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:EntityLicenses
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('EntityLicenses', EntityLicenses);

  function EntityLicenses($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/entities/:id/licenses', {id: '@_id'});
  }
}());
